'use strict';

angular.module('theme').directive('deliveryCheck', function (ZipCodeService) {
	return {
		restrict: 'E',
		templateUrl: 'component/delivery-check.html',
		scope: {
			friendCheck: '<'
		},
		controller: function ($scope) {
			$scope.status = -1;

			$scope.check = function () {
				var contactForm = angular.element(document.querySelector('#deliveryContactForm' ));
				contactForm.css('display', 'none');
				$scope.status = -2; // Loading
				ZipCodeService.check($scope.zipcodeInput).then(function (response) {
					$scope.status = response.zipcodeStatus;
				});
			};

			$scope.showContactForm = function () {
				var contactForm = angular.element(document.querySelector('#deliveryContactForm' ));
				contactForm.css('display', 'block');
				return false;
			};

			$scope.isInEventSignup = function() {
				var element = document.getElementById('compsignup');
				while (element) {
					if (element.classList && element.classList.contains('compsignup')) {
						return true;
					}
					element = element.parentElement;
				}
				return false;
			};

		}
	};
});
